module.exports = __webpack_public_path__ + "static/media/33import-67.1f03693b.xlsx";